import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';
import {FormControl} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {RegionModel} from '../../../../models/RegionModel';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import {ProviderModel} from '../../../../models/ProviderModel';
import {DesignServicesModel} from '../../../../models/DesignServicesModel';
import {CurrencyModel} from '../../../../models/CurrencyModel';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {ResourceUnitService} from '../../../general-services/service-resources-units-anagraf/resource-unit.service';
import {SizeModel} from '../../../../models/SizeModel';
import {SiteModel} from '../../../../models/SiteModel';

@Component({
  selector: 'app-resource-unit-filter',
  templateUrl: './resource-unit-filter.component.html',
  styleUrls: ['./resource-unit-filter.component.scss']
})
export class ResourceUnitFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listResourceUnitFilter: any[];
  optionSelected: any;
  formControl: FormControl = new FormControl();
  filteredOptions: BehaviorSubject<ResourcesUnitModel[]> = new BehaviorSubject<ResourcesUnitModel[]>([]);

  filterAllSettings: AllSettingsFilterModel;

  @Input() resourceUnitData: any;
  @Input() resourceUnitSelected: ResourcesUnitModel;

  @Input() inAllSettings?: boolean;
  // @Input() inAllContractMonth?: boolean;
  // @Input() idSelected?: number;
  @Input() regionForFilterInSettings?: RegionModel;
  @Input() localCustomerForFilterInSettings?: LocalCustomerModel;
  @Input() contractTypeForFilterInSettings?: ContractTypeModel;
  @Input() providerForFilterInSettings?: ProviderModel;
  @Input() designServicesForFilterInSettings?: DesignServicesModel;
  @Input() currencyForFilterInSettings?: CurrencyModel;
  @Input() sizeForFilterInSettings?: SizeModel;
  @Input() siteForFilterInSettings?: SiteModel;

  @Input() numAnnoMeseFromForFilterInSettings: number;
  @Input() numAnnoMeseToForFilterInSettings: number;

  constructor(private resourceUnitService: ResourceUnitService) {
    super();
  }

  fetchFilterData() {
    // this.loaderService.display(true);
    if (this.inAllSettings) {
      this.filterAllSettings = new AllSettingsFilterModel(
        this.regionForFilterInSettings,
        this.localCustomerForFilterInSettings,
        this.resourceUnitSelected,
        this.providerForFilterInSettings,
        this.contractTypeForFilterInSettings,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.sizeForFilterInSettings?.cod ? this.sizeForFilterInSettings : null,
        this.siteForFilterInSettings,
        null,
        null,
        null,
        null
      );
      this.resourceUnitService.getListInAllSettings(
        this.resourceUnitService.baseUrl,
        this.filterAllSettings)
        .subscribe(
          (result: any) => {
            // this.dataSource = result.content;
            // this.listData = new MatTableDataSource(this.dataSource);
            // this.paginator.pageIndex = offset.pageIndex;
            // this.paginator.showFirstLastButtons = true;
            // this.paginator.length = result.totalElements;
            // this.loaderService.display(false);

            this.listResourceUnitFilter = this.resourceUnitData = result;
            // this.optionSelected = null;
            this.filteredOptions.next(this._filter(this.optionSelected ? this.optionSelected.cod : ''));
          });
    }
    /*else if (this.inAllContractMonth) {
      this.contractFilter = new ContractualDataModel();
      this.contractFilter.numAnnoMeseFrom = this.numAnnoMeseFromForFilterInSettings;
      this.contractFilter.numAnnoMeseTo = this.numAnnoMeseToForFilterInSettings;
      this.contractFilter.region = this.regionForFilterInSettings;
      this.contractFilter.localCustomer = this.localCustomerForFilterInSettings;
      this.contractFilter.contractType = this.contractTypeForFilterInSettings;
      this.contractFilter.provider = this.providerForFilterInSettings;
      this.contractFilter.resourceUnit = this.filter;
      this.getPageSubscribe = this.resourceUnitService.getPageInAllContractMonth(offset, this.contractFilter)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    } else {
      this.getPageSubscribe = this.resourceUnitService.getPage(offset, this.filter)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    } */
  }

  ngOnInit() {
    this.fetchFilterData();
    this.formControl.setValue(this.resourceUnitSelected ? this.resourceUnitSelected.cod : null);
    this.formControl.valueChanges
      .subscribe(value => {
        const result = this._filter(value);
        this.filteredOptions.next(result);
        this.dataFiltered.emit(this.filteredOptions.value.find(x => x.cod === value || x.name === value));
      });

  }

  getSelectedObject(): ResourcesUnitModel {
    return this.filteredOptions.value.find(x => x.cod === this.formControl.value);
  }

  private _filter(value: string): ResourcesUnitModel[] {
    const filterValue = value ? value.toLowerCase() : '';
    if (!this.resourceUnitData) {
      return [];
    }
    return this.resourceUnitData.filter(
      option => option.cod.toLowerCase().includes(filterValue) || option.name.toLowerCase().includes(filterValue)
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('resourceUnitData' in changes) {
      this.listResourceUnitFilter = this.resourceUnitData;
      this.optionSelected = null;
    }
    if (
      'regionForFilterInSettings' in changes ||
      'localCustomerForFilterInSettings' in changes ||
      'contractTypeForFilterInSettings' in changes ||
      'providerForFilterInSettings' in changes ||
      'sizeForFilterInSettings' in changes ||
      'siteForFilterInSettings' in changes
    ) {
      this.fetchFilterData();
    }
    if (this.resourceUnitSelected || 'resourceUnitSelected' in changes) {
      this.optionSelected = this.resourceUnitSelected ? this.resourceUnitSelected.cod : null;
    }
    this.filteredOptions.next(this._filter(this.optionSelected ? this.optionSelected.cod : ''));
  }

  ngOnDestroy(): void {
  }
}
